export default {
  SAVE_LIST_ALL_HOLIDAY: 'SAVE_LIST_ALL_HOLIDAY',
  SAVE_SIDE_BAR_HOLIDAYS: 'SAVE_SIDE_BAR_HOLIDAYS',
}
